import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  item: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  itemTrainerName: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  itemTrainerNameTitle: {
    fontFamily: "SuisseIntlMedium",
    fontSize: 13,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 14
    }
  },
  itemIcon: {
    fontSize: 14,
    marginRight: 10,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 15
    }
  },
  itemTrainerIcon: {
    marginRight: 7,
    color: theme.palette.text.primary
  }
}));
